import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import LoginComponent from './views/login.vue'
import PeopleView from './views/people.vue'
import PeopleNewView from './views/peopleNew.vue'
import PeopleEditView from './views/peopleEdit.vue'
import PeopleOutdatedView from './views/peopleOutdated.vue'
import SelectionsView from './views/selections.vue'
import UsersView from './views/users.vue'
import SMSSentView from './views/smsSent.vue'
import HelpView from './views/help.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/people',
      name: 'people',
      component: PeopleView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: 'login',
      component: LoginComponent
    },
    {
      path: '/people-new',
      name: 'people-new',
      component: PeopleNewView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/people-edit/:id/:tabID',
      name: 'people-edit',
      component: PeopleEditView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/people-outdated',
      name: 'people-outdated',
      component: PeopleOutdatedView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/selections',
      name: 'selections',
      component: SelectionsView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/smssent',
      name: 'smssent',
      component: SMSSentView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: UsersView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/help',
      name: 'help',
      component: HelpView
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store
      .dispatch('checkLogin')
      .then(() => {
        next()
      })
      .catch(() => next(''))
  } else {
    next()
  }
})

export default router
